export function isMicrophonePermissionDeniedError(error: unknown): boolean {
  const name = error instanceof DOMException || error instanceof Error ? error.name : '';
  return name === 'NotAllowedError' || name === 'SecurityError';
}
